







import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class AnimatedTextIteration extends Vue {
  @Prop({ required: true }) readonly texts!: string[];
  @Prop({ required: true }) readonly start!: boolean;
  @Prop({ required: true }) readonly hideOnComplete!: boolean;
  @Prop({ default: 0 }) readonly delay!: number;
  @Prop({ required: true }) readonly transitionDuration!: number;
  @Prop({ required: true }) readonly visibilityDuration!: number;

  public showText = false;
  public textIdx = 0;

  public iterateText() {
    setTimeout(async () => {
      console.log('iter');

      if (this.textIdx < this.texts.length - 1) {
        this.showText = false;
        await new Promise(resolve => setTimeout(resolve, this.transitionDuration));
        this.textIdx ++;
        console.log(this.texts[this.textIdx]);
        this.showText = true;
        await new Promise(resolve => setTimeout(resolve, this.transitionDuration));
        this.iterateText();
      } else {
        if (this.hideOnComplete) {
          this.showText = false;
          await new Promise(resolve => setTimeout(resolve, this.transitionDuration));
        }
        this.$emit('completed');
      }
    }, this.visibilityDuration);
  }

  @Watch('start', {
    immediate: false
  })
  async isStart() {
    if (!this.start) {
      return;
    }

    this.showText = true;
    // Allow enough offset to make a smooth transition
    if (this.delay > 0) {
      await new Promise(resolve => setTimeout(
        resolve,
        this.delay + this.transitionDuration
      ));
    }
    this.iterateText();
  }

}
